import { EmptyState } from '@atlas/ui-components'
import { Button } from '@atlas/ui-primitives'
import type { StepFooterCta } from '@/components/work-orders/WorkOrderStepFooter'

/** A step whose screen is not built yet: its name, and the moves the footer does not carry. */
export function PlaceholderStep({ stage, moves }: { stage: string; moves: readonly StepFooterCta[] }) {
	return (
		<EmptyState
			title={stage}
			description="This step's screen is not built yet."
			action={
				moves.length ? (
					<div className="flex flex-wrap justify-center gap-2">
						{moves.map((move) => (
							<Button
								key={move.label}
								variant="outline"
								onPress={move.onPress}
								isDisabled={move.isDisabled || move.isPending}
							>
								{move.label}
							</Button>
						))}
					</div>
				) : undefined
			}
		/>
	)
}
